export * from './searchable-header-label.module';
export * from './searchable-header-label.component';
